

$(document).ready(function() {
  //parallax scroll
  $(window).on("load scroll", function() {
    var parallaxElement = $(".Image-Scroll-Section:even img.two"),
      parallaxQuantity = parallaxElement.length;
    window.requestAnimationFrame(function() {
      for (var i = 0; i < parallaxQuantity; i++) {
        var currentElement = parallaxElement.eq(i),
          windowTop = $(window).scrollTop(),
          elementTop = currentElement.offset().top,
          elementHeight = currentElement.height(),
          viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
          scrolled = windowTop - elementTop + viewPortHeight;
        currentElement.css({
          transform: "translate3d(0," + scrolled * +0.23 + "px, 0)"
        });  
      }
    });
  }); 
}); 

$(document).ready(function() {
  //parallax scroll
  $(window).on("load scroll", function() {
    var parallaxElement = $(".Image-Scroll-Section:even img.one"),
      parallaxQuantity = parallaxElement.length;
    window.requestAnimationFrame(function() {
      for (var i = 0; i < parallaxQuantity; i++) {
        var currentElement = parallaxElement.eq(i),
          windowTop = $(window).scrollTop(),
          elementTop = currentElement.offset().top,
          elementHeight = currentElement.height(),
          viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
          scrolled = windowTop - elementTop + viewPortHeight;
        currentElement.css({
          transform: "translate3d(0," + scrolled * -0.13 + "px, 0)"
        });
      }
    });
  });
});


$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 150) {
        $(".site-header").addClass("site-header--stuck site-header--opening");
    } else {
        $(".site-header").removeClass("site-header--stuck site-header--opening");
    }
});

var swiper = new Swiper('.slider-logs', {
  slidesPerView: 5,
  spaceBetween: 0,
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },    
  autoplay: {
    delay: 5000
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 20
    }
  }
});

var swiper = new Swiper('.slider-image', {
  slidesPerView: 1,
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },    
  autoplay: {
    delay: 3000
  },
    breakpoints: {
    767: {
      slidesPerView: 1,
      navigation: true,
     paginationClickable: true,
    }
  }
});

var swiper = new Swiper('.slider-text', {
  direction: 'vertical',
  slidesPerView: 1,
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },    
  autoplay: {
    delay: 2000
  },
  breakpoints: {
    767: {
      slidesPerView: 1,
      navigation: false,
      paginationClickable: false,
    }
  }
});



var mySwiper = new Swiper('.scene_swiper-container', {
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper_rightx',
    prevEl: '.swiper_lefts',
  }, 
  grabCursor: true,
  autoHeight: true //enable auto height
});



// faq nav-tab
jQuery(document).ready(function() {
  jQuery('.nav-tabs > div > a').click(function(event) {
    event.preventDefault(); //stop browser to take action for clicked anchor
    //get displaying tab content jQuery selector
    var active_tab_selector = jQuery('.nav-tabs > div.active > a').attr('href');
    //find actived navigation and remove 'active' css
    var actived_nav = jQuery('.nav-tabs > div.active');
    actived_nav.removeClass('active');
    //add 'active' css into clicked navigation
    jQuery(this).parents('div').addClass('active');
    //hide displaying tab content
    jQuery(active_tab_selector).removeClass('active');
    jQuery(active_tab_selector).addClass('hide');
    //show target tab content
    var target_tab_selector = jQuery(this).attr('href');
    jQuery(target_tab_selector).removeClass('hide');
    jQuery(target_tab_selector).addClass('active');
  });
}); 


// faq openclose
jQuery(document).ready(function() {
  jQuery(".psd-one").on("click", function(){
    if( jQuery(this).parent().hasClass("active") ){
      jQuery(this).next().slideUp();
      jQuery(this).parent().removeClass("active");
    }
    else{
      jQuery(".psd-two").slideUp();
      jQuery(".bd-faq").removeClass("active");
      jQuery(this).parent().addClass("active");
      jQuery(this).next().slideDown();
    }
  });
});

// faq showmore
jQuery('.moreless-button').click(function() {
  jQuery('.moretext').slideToggle();
  if (jQuery('.moreless-button').text() == "Read more") {
    jQuery(this).text("Read less")
  } else {
    jQuery(this).text("Read more")
  }
});











$("#consales").click(function(){
  openPopus('#ContactModalsales');
});


var modal = new theme.Modals('ContactModal', 'video-modal', {
  closeOffContentClick: true,
  bodyOpenClass: ['modal-open', 'video-modal-open'],
  solid: true
});

setTimeout(function(){
  $('.index-section--hero').css('display','block');
}, 1500);


$(document).ready(function(){
  $('.popup-btn-one').click(function(){ 
    var popupBlock = $('#'+$(this).data('popup'));
    popupBlock.addClass('active')
    .find('.fade-out').click(function(){
      popupBlock.css('opacity','0').find('.popup-content-one').css('margin-top','350px');        
      setTimeout(function(){
        $('.popup').removeClass('active');
        popupBlock.css('opacity','').find('.popup-content-one').css('margin-top','');
      }, 600);
    });
  });
});
$(document).ready(function(){
  $('.popup-btn-two').click(function(){ 
    var popupBlock = $('#'+$(this).data('popup'));
    popupBlock.addClass('active')
    .find('.fade-out').click(function(){
      popupBlock.css('opacity','0').find('.popup-content-one').css('margin-top','350px');        
      setTimeout(function(){
        $('.popup').removeClass('active');
        popupBlock.css('opacity','').find('.popup-content-one').css('margin-top','');
      }, 600);
    });
  });
});
$(document).ready(function(){
  $('.popup-btn-three').click(function(){ 
    var popupBlock = $('#'+$(this).data('popup'));
    popupBlock.addClass('active')
    .find('.fade-out').click(function(){
      popupBlock.css('opacity','0').find('.popup-content-one').css('margin-top','350px');        
      setTimeout(function(){
        $('.popup').removeClass('active');
        popupBlock.css('opacity','').find('.popup-content-one').css('margin-top','');
      }, 600);
    });
  });
});
$(document).ready(function(){
  $('.popup-btn-four').click(function(){ 
    var popupBlock = $('#'+$(this).data('popup'));
    popupBlock.addClass('active')
    .find('.fade-out').click(function(){
      popupBlock.css('opacity','0').find('.popup-content-one').css('margin-top','350px');        
      setTimeout(function(){
        $('.popup').removeClass('active');
        popupBlock.css('opacity','').find('.popup-content-one').css('margin-top','');
      }, 600);
    });
  });
});

var btn = $('#top-button');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});


let slick1 = $(".slider").slick({
  dots: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 9000,
  loop: true,
  arrow: true,
  speed: 1000,
  fade: true,
  cssEase: 'linear',
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: '<button class="slide-arrow prev-arrow"></button>',
  nextArrow: '<button class="slide-arrow next-arrow"></button>'
});


setTimeout(function(){$(".banner-slider-new").css("opacity","1");}, 800);

var id = window.location.hash;

if(id == '#compatible'){
  $('html, body').animate({
    scrollTop: $("#shopify-section-template--15892065255679__164983732102ac9c34").offset().top - 150
  }, 1000);
}


// $("li.nav-text a[data-ids='#one']").eq('0').addClass("active");
// $("li.nav-text a").click(function(){
//   $(this).addClass("active");
//   var secId = $(this).attr("data-ids");
//   $('html, body').animate({
//     scrollTop: $(secId).offset().top - 0
//   }, 1600);
//   $(this).addClass("active");
//   $(this).siblings().removeClass("active");
// });


// const sections = document.querySelectorAll("section[id]");

// window.addEventListener("scroll", navHighlighter);

// function navHighlighter() {

//   let scrollY = window.pageYOffset;
  
//   sections.forEach(current => {
//     const sectionHeight = current.offsetHeight;
//     const sectionTop = current.offsetTop + 100;
//     sectionId = current.getAttribute("id");
//     if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight){
//       $(".navigation a[data-ids='#" + sectionId + "']").addClass("active");
//     } else {
//       $(".navigation a[data-ids='#" + sectionId + "']").removeClass("active");
//     }
//   });
// }




//$("body").css("paddingTop", $(".navbar").innerHeight());
$(".new-add-think li").eq(0).find("a").addClass("active");
$(function () {
  $(".navbar li a").click(function (e) {
    "use strict";
    e.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $("#" + $(this).data("scroll")).offset().top - 100,
      },
      1000
    );
  });
  $(".navbar li a").click(function () {
    $(this).addClass("active");
    $(this).parent().siblings().find("a").removeClass("active");
  });
 /* $(window).scroll(function () {
    $(".block").each(function () {
      
      if ($(window).scrollTop() >= $(this).offset().top) {
        var blockId = $(this).attr("id");
        $(".navbar a").removeClass("active");
        $('.navbar li a[data-scroll="' + blockId + '"]').addClass("active");
      }
    });
  }); */
});

